import {
  deploymentTopologySchema,
  getDeploymentTopologyPath,
} from '@wix/cli-astro-definitions';
import type {
  DeploymentTopologyEnvironmentSchema,
  DeploymentTopologyEnvironmentType,
} from '@wix/cli-astro-definitions';
import { pathExists, readJson, writeJson } from '@wix/cli-fs';

async function readDeploymentTopology(projectFolder: string) {
  const path = getDeploymentTopologyPath(projectFolder);

  if (await pathExists(path)) {
    try {
      const deployment = await readJson(path);
      return deploymentTopologySchema.parse(deployment);
    } catch {
      // ignore any failures while reading/parsing the .wix/topology.json
      // it's a temporary file, shouldn't break the app.
    }
  }

  return {};
}

export async function writeDeploymentTopologyEnvironment(
  projectFolder: string,
  environment: DeploymentTopologyEnvironmentType,
  entry: DeploymentTopologyEnvironmentSchema
): Promise<void> {
  const topology = await readDeploymentTopology(projectFolder);
  topology[environment] = entry;
  const path = getDeploymentTopologyPath(projectFolder);
  await writeJson(path, topology, { spaces: 2 });
}
